// src/eventing/nova-eventing-provider.tsx
import {
  createContext,
  createElement,
  useContext,
  useMemo
} from "react";
import {InputType} from "@nova/types";
import {mapEventMetadata} from "./react-event-source-mapper.mjs";
import invariant from "invariant";
var NovaEventingContext = createContext(null);
var NovaEventingProvider = ({children, eventing, reactEventMapper}) => {
  const reactEventing = useMemo(() => ({
    bubble: (eventWrapper) => {
      const mappedEvent = reactEventMapper ? reactEventMapper(eventWrapper) : mapEventMetadata(eventWrapper);
      return eventing.bubble(mappedEvent);
    },
    generateEvent: (eventWrapper) => {
      var _a;
      const mappedEvent = {
        event: eventWrapper.event,
        source: {
          inputType: InputType.programmatic,
          timeStamp: (_a = eventWrapper.timeStampOverride) != null ? _a : Date.now()
        }
      };
      return eventing.bubble(mappedEvent);
    }
  }), [eventing, reactEventMapper]);
  return /* @__PURE__ */ createElement(NovaEventingContext.Provider, {
    value: reactEventing
  }, children);
};
NovaEventingProvider.displayName = "NovaEventingProvider";
var useNovaEventing = () => {
  const eventing = useContext(NovaEventingContext);
  invariant(eventing, "Nova Eventing provider must be initialized prior to consumption!");
  return eventing;
};
export {
  NovaEventingProvider,
  useNovaEventing
};
